import request from '../../config/axiosConfig';
import {
  GET_LIST_EVENT_CATEGORIES, CREATE_EVENT_CATEGORY,
  UPDATE_EVENT_CATEGORY, DELETE_EVENT_CATEGORY, LIST_ACTIVE_EVENT_CATEGORIES
} from '../../constants/apiEndPoint';

const eventCategoryService = {
  // Controller đọc limit/page/từ khóa từ req.body (validator đóng) nên phải gửi body whitelist,
  // và map từ khóa chung "search" của CrudPage sang đúng key "title" API nhận
  getList: async (params = {}) => {
    const { page = 1, limit = 10, search, title, parent_id } = params;
    const body = { page, limit };
    const term = title ?? search;
    if (term) body.title = term;
    // Filter "Tất cả" gửi '' — Joi.number() sẽ reject nên chỉ gửi khi có giá trị thật
    if (parent_id !== undefined && parent_id !== null && parent_id !== '') body.parent_id = Number(parent_id);
    const { data } = await request({ url: GET_LIST_EVENT_CATEGORIES, method: 'POST', data: body });
    return data;
  },

  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_EVENT_CATEGORY, method: 'POST', data: dataBody });
    return data;
  },

  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_EVENT_CATEGORY, method: 'POST', data: { id, ...dataBody } });
    return data;
  },

  delete: async (id) => {
    const { data } = await request({ url: DELETE_EVENT_CATEGORY, method: 'POST', data: { id } });
    return data;
  },

  listActive: async () => {
    const { data } = await request({ url: LIST_ACTIVE_EVENT_CATEGORIES, method: 'POST' });
    return data?.data || data;
  },
};

export default eventCategoryService;
